import { Box, styled } from "@mui/material";
import { mediaQueries } from "../theme/breakpoints";
import colors from "../theme/colors";
import fonts from "../theme/fonts";
import { PLAYER } from "../types/players";
import { teamOnePlayers, teamTwoPlayers } from "../types/teams";

interface NameRowProps {
  team1Score?: number;
  team2Score?: number;
  throwNumber: number;
  activeThrower: PLAYER;
}

export default function NameRow({
  team1Score,
  team2Score,
  throwNumber,
  activeThrower,
}: NameRowProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="space-between"
      height="100%"
    >
      <Box display="flex" alignItems="center" width="100%">
        <NameBox
          player={PLAYER.FIRST}
          active={teamOnePlayers.includes(activeThrower)}
        >
          {teamOnePlayers.includes(activeThrower) ? activeThrower : "Team 1"}
          <Score>{team1Score}</Score>
        </NameBox>
        <NameBox
          player={PLAYER.SECOND}
          active={teamTwoPlayers.includes(activeThrower)}
        >
          {teamTwoPlayers.includes(activeThrower) ? activeThrower : "Team 2"}
          <Score>{team2Score}</Score>
        </NameBox>
      </Box>
      <Box display="flex" justifyContent="center">
        <ThrowBox>Throw: {throwNumber}</ThrowBox>
      </Box>
    </Box>
  );
}

const BaseBox = styled(Box)({
  fontSize: fonts.size.mediumLarge,
  fontFamily: fonts.family.chalk,
});

const Score = styled(Box)({
  fontSize: fonts.size.large,
  [mediaQueries.notMobile]: {
    display: "none",
  },
});
interface NameBoxProps {
  active: boolean;
  player: PLAYER;
}
const NameBox = styled(BaseBox)<NameBoxProps>(({ active, player }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: "85%",
  justifyContent: "center",
  color: !active
    ? colors.transparentLightBeige
    : teamOnePlayers.includes(player)
    ? colors.darkGray
    : colors.lightBeige,
  backgroundColor: !active
    ? "transparent"
    : teamOnePlayers.includes(player)
    ? colors.lightBeige
    : colors.darkGray,
  [mediaQueries.mobile]: {
    width: "30%",
    fontSize: fonts.size.medium,
  },
}));

const ThrowBox = styled(BaseBox)({
  color: colors.lightBeige,
  fontSize: fonts.size.large,
  border: "4px double black",
  padding: " 5px 25px",
  width: "300px",
  [mediaQueries.mobile]: {
    fontSize: fonts.size.medium,
    width: "50%",
  },
});
